export default {
  globals: {
    notUTF8Encoded: 'Codificación no admitida',
    language: 'Idioma',
    activated: 'Activado',
    notAValidSerial: 'No es un serial válido',
    confirmDeleteTitle: 'Esta acción es irreversible',
    confirmDeleteText: '¿Desea eliminar el/los elementos?',
    confirmExitTitle: 'Hay cambios sin guardar',
    confirmExitText: '¿Desea salir sin guardar los cambios?',
    confirmResetTitle: 'Esta acción es irreversible',
    confirmResetText: 'Si restauras, perderás todos los cambios hechos en el mapa',
    confirmInvalidateText: '¿Desea invalidar el pedido?',
    notEnoughPermissions: 'No tiene suficientes permisos para acceder a este módulo',
    languageNotSupported: 'El idioma que está tratando de utilizar no está soportado por el momento.\n Si desea una traducción personalizada por favor contacte con soporte',
    notEnoughPermissionsRes: 'No tiene suficientes permisos para acceder a este recurso',
    notBought: 'No tiene este módulo contratado, contacte <a href="mailto:info@foodeo.es" style="color: blue">info@foodeo.es</a> para más información',
    mustAddProducts: 'Debe agregar productos',
    localRequestsMustHaveTable: 'Pedidos de tipo Local deben tener una mesa asignada',
    domicilePickUpRequestsMustHaveClient: 'Pedidos de tipo Domicilio/A Recoger deben tener un cliente asignado',
    domicilePickUpRequestsMustHaveShiftTime: 'Pedidos de tipo Domicilio/A Recoger deben tener un turno asignado',
    domicileRequestsMustHaveAddress: 'Los pedidos de tipo domicilio deben tener una dirección',closeAllIfContinue: 'Todos sus pedidos pasarán a estado cerrado si continúa',
    notFound: 'Está tratando de acceder a una ruta que no existe, por favor navegue por el menú lateral',
    subdomainNotFound: '¡Ups! Parece que algo ha ido mal, la dirección que estás buscando no es correcta. Por favor inténtalo de nuevo o contacta con tu administrador',
    loseAllIfContinue: 'Hay cambios que no se han guardado.¿Estás seguro que quieres salir sin guardarlos?',
    loseAllIfClose: 'Hay cambios que no se han guardado.¿Estás seguro que quieres cerrar sin guardarlos?',
    noResults: 'Sin Resultados',
    areYouSure: '¿Estás seguro?',
    yes: 'Sí',
    no: 'No',
    search: 'Búsqueda',
    of: 'de',
    image: 'Imagen',
    actions: 'Acciones',
    noElements: 'Sin Elementos',
    noElement: 'Sin Elemento',
    translations: 'Traducciones',
    required: 'Requerido',
    onlyMoreThanZero: 'Solo números mayores que 0',
    noNegative: 'Solo números positivos',
    dontAllowMaximize: 'Su navegador no permite maximizar',
    multiSelection: 'Selección Múltiple',
    printing: 'Imprimiendo Ticket',
    mustConfigureRequestType: 'Debe configurar este tipo de pedido',
    insertingElement: 'Insertando Elemento...',
    editingElement: 'Editando Elemento...',
    payingElement: 'Pagando Elemento...',
    exit: 'Salir',
    currency: 'Moneda',
    nonAbleToSplitByProducts: 'No puedes separar por productos cuando tienes un descuento global en el pedido.',
    nonAbleToDiscountToProduct: 'No se puede hacer un descuento numérico a un producto, aplícalo a todo el pedido.',
    months: {
      january: 'Enero',
      february: 'Febrero',
      march: 'Marzo',
      april: 'Abril',
      may: 'Mayo',
      june: 'Junio',
      july: 'Julio',
      august: 'Agosto',
      september: 'Septiembre',
      october: 'Octubre',
      november: 'Noviembre',
      december: 'Diciembre',
    },
    weekDays: {
      sunday: 'Domingo',
      monday: 'Lunes',
      tuesday: 'Martes',
      wednesday: 'Miércoles',
      thursday: 'Jueves',
      friday: 'Viernes',
      saturday: 'Sábado',
    },
    dates: {
      today: 'Hoy',
      yesterday: 'Ayer',
      lastSeven: 'Últimos 7 días',
      lastThirty: 'Últimos 30 días',
      firstTrim: 'Primer Trimestre',
      secondTrim: 'Segundo Trimestre',
      thirdTrim: 'Tercer Trimestre',
      fourthTrim: 'Cuarto Trimestre',
      currentMonth: 'Mes Actual',
      lastMonth: 'Mes Anterior',
      allYear: 'Todo el año',
      last3Month: 'Últimos 3 meses'
    },
    unitTypes: {quantity: 'Cantidad por Unidad', volume: 'Volumen', weight: 'Peso'},
    logoSizeValidateMessage: 'El tamaño de la imagen debe ser inferior a 100 kb',
    headerImageSizeValidateMessage: 'El tamaño de la imagen de cabezera debe ser inferior a 1000 kb',
    kioskHeaderImageSizeValidateMessage: 'El tamaño de la imagen de cabezera debe ser inferior a 5 MB',
    measures: {
      ml: 'Mililitro',
      cl: 'Centilitro',
      dl: 'Decilitro',
      L: 'Litro',
      g: 'Gramo',
      kg: 'Kilogramo',
      oz: 'Onza',
      lb: 'Libra',
      ud: 'Unidad',
    },
    selectUser: 'Seleccionar Empleado',
    moreFilters: 'Más filtros',
    noObservations: 'Sin observaciones',
    loading: 'Cargando...',
    confirmDuplicateTitle: 'Duplicar producto',
    confirmDuplicateText: '¿Estás seguro que quieres duplicar el producto',
    confirmUpdateCategoryTitle: 'Actualizar categoría',
    confirmUpdateCategoryText: 'Seleccionar nueva categoría',
    confirmDeleteBody: '¿Estás seguro que quieres eliminar',
    confirmDeleteproductsText: 'los productos seleccionados?',
    confirmDeletecategoriesText: 'las categorías seleccionadas?',
    confirmDeleteawardsText: 'los premios seleccionados?',
    confirmDeleteemployeesText: 'los empleados seleccionados?',
    confirmDeleteclientsText: 'los clientes seleccionados?',
    confirmDeletetablesText: 'las mesas seleccionadas?',
    confirmDeletezonesText: 'las zonas seleccionadas?',
    confirmDeletescreensText: 'las pantallas seleccionadas?',
    confirmDeleteprintersText: 'las impresoras seleccionadas?',
    confirmDeletefamiliesText: 'las familias seleccionadas?',
    confirmDeleteshiftsText: 'los turnos seleccionados?',
    confirmDeletemodifiersText: 'los modificadores seleccionados?',
    confirmDeleteoptionsText: 'las opciones seleccionadas?',
    'confirmDeletebooking-optionsText': 'las opciones seleccionadas?',
    confirmDeletestockText: 'el almacén seleccionado?',
    confirmDeleteproviderText: 'el proveedor seleccionado?',
    confirmDeleteingredientsText: 'los ingredientes seleccionados?',
    confirmDeletereportsText: 'el reporte seleccionado?',
    confirmDeleteunitsText: 'las unidades de medidas seleccionadas?',
    confirmDeleteoffersText: 'las ofertas seleccionadas?',confirmDeleteZoneText: 'la zona seleccionada?',
    resetPasswordText: 'Introduce el email con el que te registraste y te enviamos la nueva contraseña por correo, mira en la bandeja de spam de tu correo por si acaso.',
    forgotPassword: '¿Olvidaste tu contraseña?',
    resetPasswordSent: 'La contraseña se ha enviado al correo solicitado correctamente',
    userNotFound: 'Usuario no encontrado',
    localDisabled: 'Local desactivado. Por favor, contacte con soporte.',
  },
  types: {
    toBarAdd: 'Insertar',
    add: 'Insertar',
    edit: 'Editar',
    readOnly: 'Sólo Lectura',
    save: 'Guardar',
    duplicate: 'Duplicar'
  },
  actions: {
    select: 'Seleccionar',
    return: 'Regresar',
    reset: 'Resetear',
    markAll: 'Marcar todos',
    accept: 'Aceptar',
    clean: 'Limpiar',
    send: 'Enviar',
    cancel: 'Cancelar',
    continue: 'Continuar',
    close: 'Cerrar',
    edit: 'Editar',
    details: 'Detalles',
    delete: 'Eliminar',
    deleteSelected: 'Eliminar Seleccionados',
    insert: 'Agregar',
    recharge: 'Recargar',
    search: 'Buscar',
    selected: 'Seleccionados',
    save: 'Guardar',
    closeWithoutSaving: 'Salir sin guardar',
    print: 'Imprimir',
    invalidate: 'Invalidar',
    invite: 'Invitar',
    createInvoice: 'Factura',
    add: 'Añadir',
    apply: 'Aplicar',
    restore: 'Restaurar',
    new: 'Nuevo',
    reject: 'RECHAZAR',
    exitAndSave: 'Exit and Save',
    exit: 'Salir',
    goBack: 'Volver',
    editMap: 'Mapa',
    login: 'Iniciar Sesión',
    closeAll: 'Cerrar Todos',
    retry: 'Volver a Intentar',
    selectOrInsert: 'Seleccione o Inserte una Mesa',
    preview: 'Ver',
    duplicate: 'Duplicar',
    update: 'Actualizar'
  },
  modules: {
    'product': 'Producto',
    'products': 'Productos',
    'tables': 'Mesas',
    'table': 'Mesa',
    'screens': 'Pantallas',
    'screen': 'Pantalla',
    'zone': 'Zona',
    'zones': 'Zonas',
    'user': 'Usuario',
    'users': 'Usuarios',
    'printer': 'Impresora',
    'printers': 'Impresoras',
    'client': 'Cliente',
    'clients': 'Clientes',
    'request': 'Pedido',
    'requests': 'Pedidos',
    'cashRegister': 'Cierre de Caja',
    'box_report': 'Cierre de Caja',
    'calendar': 'Calendario',
    'reports': 'Reportes',
    'stocks': 'Almacenes',
    'stock': 'Almacén',
    'settings': 'Configuración',
    'booking-options': 'Opciones',
    'bookings': 'Reservas',
    'shifts': 'Turnos',
    'shift': 'Turno',
    'category': 'Categoría',
    'categories': 'Categorías',
    'employee': 'Empleado',
    'employees': 'Empleados',
    'distribution': 'Distribución',
    'tableMap': 'Mapa de mesas',
    'awards': 'Premios',
    'ingredient': 'Ingrediente',
    'ingredients': 'Ingredientes',
    'provider': 'Proveedor',
    'providers': 'Proveedores',
    'purchase': 'Compra',
    'purchases': 'Compras',
    'tpv': 'TPV',
    'family': 'Familia',
    'families': 'Familias',
    'stockReport': 'Stock',
    'stock_report': 'Stock',
    'card': 'Carta',
    'cashiers': 'Cajones',
    'cashier': 'Cajón',
    'modifiers': 'Modificadores',
    'modifier': 'Modificador',
    'option': 'Opción',
    'options': 'Opciones',
    'addresses': 'Direcciones',
    'address': 'Dirección',
    'recipes': 'Escandallos',
    'recipe': 'Escandallo',
    'TPV': 'TPV',
    'purchaseOrders': 'Pedidos',
    'purchaseOrder': 'Pedido',
    'unit': 'Unidad',
    'units': 'Unidades',
    'offers': 'Ofertas (pronto)',
    'loyalty': 'Fidelización',
    'timeTracking': 'Fichajes (pronto)',
  },
  address: {
    major: 'Principal',
    markAsDefault: 'Marcar como predeterminada',
    active: 'Predeterminada',
    noDirections: 'Sin Direcciones',
    reference: 'Observaciones',
    needPrincipal: 'Debe seleccionar una direccion predeterminada',
    cantNoDeletePrincipalAddress: 'No puede eliminar la dirección principal',
  },
  auth: {
    email: 'Correo',
    password: 'Contraseña',
    selectTPV: 'Seleccionar TPV',
  },
  product: {
    name: 'Nombre',
    category: 'Categoría',
    serial: 'No. Serie',
    image: 'Imagen',
    price: 'Precio',
    purchasePrice: 'Precio de compra',
    description: 'Descripción',
    allergen: 'Alérgenos',
    noProducts: 'Sin productos',
    combined: 'Combinados',
    aggregated: 'Agregados',
    unitType: 'Tipo de unidad',
    unit: 'Unidad de medida',
    amountOf: 'Cantidad de',
    measures: 'Medidas',
    minStock: 'Cantidad mínima para notificar',
    minMessage: 'Si se deja vacío nunca notificará',
    orderGroup: 'Agrupar',
    orderGroupTypes: {
      incoming: 'Entrante',
      first_plate: 'Primer Plato',
      second_plate: 'Segundo Plato',
      desserts: 'Postre',
      no_group: 'Sin orden',
    },
    applyPriceByZones: 'Aplicar precio distintos por zona',
    qty_existence: 'Cantidad en existencia',
    order: 'Orden',
    hasModifiers: 'Tiene Modificadores',
    cantSubstractPayed: "No puede quitar productos pagados",
    cantSubstractPrice: "El precio total no puede disminuir de lo pagado",
  },
  offer: {
    name: 'Nombre',
    code: 'Código',
    discount: 'Descuento',
    discountType: 'Tipo de descuento',
    start: 'Inicio',
    end: 'Fin',
    noOffers: 'Sin Ofertas',
    description: 'Descripción',
    from: 'Desde',
    to: 'Hasta',
    validity: 'Validez',
    requiredName: 'El nombre es requerido',
    requiredDate: 'La fecha es requerida',
    datesNotCorrect: 'La fecha final no puede ser anterior a la fecha inicial',
    hour: 'Hora',
  },
  ingredient: {
    name: 'Nombre',
    serial: 'No. Serie',
    image: 'Imagen',
    price: 'Precio actual',
    description: 'Descripción',
    noIngredients: 'Sin ingredientes',
    unitType: 'Tipo de Unidad',
    unit: 'Unidad de medida',
    amountOf: 'Cantidad de',
    oldPrice: 'Precio anterior',
    tendency: 'Tendencia',
    sku: 'SKU',
  },
  family: {name: 'Nombre', categories: 'Categorías', printers: 'Impresoras', noFamilies: 'Sin Familias'},
  table: {
    noTables: 'Sin Mesas',
    name: 'Nombre',
    tableName: 'Nombre Mesa',
    qr: 'QR',
    changeTable: 'Cambiar mesa',
    fusionTable: 'Fusionar mesa',
    sameTableValidation: 'No puede seleccionar la misma mesa',
    emptyFieldsErrorMsg: 'Hay mesas con el/los campos %{field} vacíos.',
    fusionTableAlert: 'Si continua perderá los descuentos y pagos parciales que pueda tener la mesa. ¿Desea continuar?',
    newTable: '+ Nueva Mesa',
    deleteTable: 'Borrar Mesa',
    confirmChange: '¿Estás seguro que quieres cambiar la comanda a ota mesa?',
  },
  cashier: {
    noCashiers: 'Sin cajones',
    name: 'Nombre',
    printer: 'Impresora',
    pulse: 'Pulso',
    port: 'Puerto',

  },
  screen: {
    noScreens: 'Sin Pantallas',
    name: 'Nombre',
    categories: 'Categorias',
    tpv: 'TPV',
    showVarious: 'Mostrar productos varios',
  },
  provider: {
    name: 'Nombre',
    phone: 'Teléfono',
    email: 'Correo',
    category: 'Categoría',
    noProviders: 'Sin Proveedores',
    description: 'Descripción',
  },
  award: {
    noAwards: 'Sin premios',
    name: 'Nombre',
    image: 'Imagen',
    coins: 'Puntos',
  },
  zone: {
    noZone: 'Sin Zonas',
    name: 'Nombre',
    nameZone: 'Nombre Zona',
    selectTPV: 'Seleccionar TPV',
    mainTPV: 'Seleccionar TPV Principal',
    secondaryTPV: 'Seleccionar TPV Secundario',
    withoutAssign: 'Sin Asignar',
    mainPrinter: 'Impresora Principal',
    validateTablesCount: 'No puede añadir más de',
    tables: 'mesas',
    insertTables: 'Agregar mesas',
    deleteZone: 'Borrar Zona',
    newZone: '+ Nueva Zona'
  },
  role: {
    name: 'Nombre',
    description: 'Descripción',
  },
  user: {
    noUsers: 'Sin Usuarios',
    firstName: 'Nombre',
    lastName: 'Apellidos',
    email: 'Correo',
    role: 'Rol',
    phN: 'Tlf',
    phone: 'Número Telefónico',
    mustBeValidEmail: 'Debe ser un correo válido',
    address: 'Dirección',
    pass: 'Contraseña',
    passConfirm: 'Confirmar Contraseña',
    unmatchedPass: 'Las Contraseñas no coinciden',
    permissions: 'Permisos',
  },
  client: {
    noClients: 'Sin Clientes',
    firstName: 'Nombre',
    lastName: 'Apellidos',
    username: 'Nombre de Usuario',
    email: 'Correo',
    phone: 'Número Telefónico',
    city: 'Provincia',
    town: 'Población',
    address: 'Dirección',
    fiscalName: 'Nombre Fiscal',
    fiscalAddress: 'Dirección Fiscal',
    postalCode: 'Código Postal',
    dniCif: 'DNI/CIF',
    searchClient: 'Buscar Cliente',
    newClient: '+Nuevo Cliente',
    street: 'Calle',
    streetNumber: 'Número de Calle',
    floorAndDoor: 'Piso y puerta',
  },
  recipe: {
    price: 'Precio',
    platePrice: 'Coste del plato',
    benefit: 'Beneficio',
    margin: 'Margen',
    info: 'El markup o margen de precio neto se refiere al porcentaje adicional que se agrega al costo de los productos o servicios para determinar su precio de venta al cliente. Es una medida clave para calcular la rentabilidad de un negocio en la industria de la hostelería. Se recomiendo que el margen mínimo en hostelería debe ser de al menos el 300%.',
  },
  purchase: {
    noPurchases: 'Sin Compras',
    product: 'Productos',
    provider: 'Proveedor',
    unitaryPrice: 'Precio Unitario',
    destination: 'Destinación',
    amount: 'Cantidad',
    serial: 'No. Serie',
    status: 'Estado',
    createdDate: 'Fecha de Creación',
    totalPrice: 'Precio Total',
    insertAnother: 'Añadir Otro',
    productOrIngredient: 'Producto/Ingrediente',
    newPurchase: 'Nueva Compra',
    addProductToList: 'Añadir producto a la lista',
    addProduct: 'Añadir producto',
    productType: 'Tipo de producto',
    purchaseList: 'Lista de la compra',
    purchasePrice: 'Precio compra',
    unit: 'Ud de medida',
    iva: 'IVA',
    total: 'Total',
    subtotal: 'Subtotal',
    noProvider: 'Sin proveedor',
    totalPriceWithIVA: 'Total con IVA',
    generalInfo: 'Información General',
    pay: 'Pago',
    payDate: 'Fecha de pago',
    successPurchase: 'Compra realizada con éxito',
    successUpdatePurchase: 'Compra editada con éxito',
    payPurchase: 'Pagar Compra',
    selectPaymentMethod: 'Seleccione tipo de pago',
    date: 'Fecha compra',
  },
  purchaseStatus: {
    pending: 'Pendiente',
    bought: 'Comprado',
    paid: 'Pagado',
  },
  purchaseOrder: {
    newPurchaseOrder: 'Nuevo Pedido',
    noPurchaseOrder: 'Sin Pedidos',
    date: 'Fecha pedido',
    status: 'Estado',
    convertToPurchase: 'Convertir',
    confirmConvert: '¿Desea convertir este pedido en compra?',
    successPurchaseOrder: 'Pedido realizado con éxito',
    successUpdatePurchaseOrder: 'Pedido editado con éxito',
    sendMailTo: '¿Desea enviar el pedido a',
    toEmail: 'al correo',
    sendOrder: 'Enviar pedido',
    checkProviderEmail: 'El proveedor seleccionado no tiene correo asignado',
  },
  printer: {
    noPrinters: 'Sin Impresoras',
    main: 'Principal',
    mainPrinter: 'Impresora Principal',
    mainPrinterOf: 'Impresora principal de',
    mainPrinterMenu: 'La impresora principal es la que imprime el ticket de cliente (la cuenta). Solo puede haber una impresora principal por TPV.',
    secondaryPrinterOf: 'Impresora secundaria de',
    secondaryPrinterMenu: 'Las impresoras secundarias son las impresoras de cocina, las que sacan los tickets de cocina.',
    printerCategoriesMenu: 'Asigna las categorias que quieres que se impriman por esta impresora.',
    printerZonesMenu: 'Asigna las zonas que quieres que se impriman por esta impresora.',
    printerFamiliesMenu: 'Utiliza esta opción solamente si quieres que esta impresora saque  varios tickets en cada pedido en función de la familia que tenga. Esta opción requiere que esté activada la opción de Imprimir por familia en Configuracion>Ticket.',
    name: 'Nombre',
    categories: 'Categorías',
    allowToMarch: 'Permitir marchar',
    printInvoice: 'Imprimir Factura',
    width: 'Ancho',

  },
  reports: {
    selectReport: 'Seleccionar Reporte',
    locales: 'Locales',
    actionNotAllowed: 'Debe autenticarse en el local seleccionado para realizar esta acción',
    views: {
      dash: 'Dashboard',
      sales: 'Ventas',
      expenses: 'Gastos',
      reportsInfo: 'Informes',
      predictions: 'Predicciones',
    },
    payment_types: {
      credit_card: 'Tarjeta de Crédito',
      cash: 'Efectivo',
      split: 'Separado',
      split_product: 'Separado por productos',
      split_price: 'Separado por precio',
      transfer: 'Transferencia',
    },
    types: {
      sales: 'Ventas',
      products: 'Productos',
      requestHistory: 'Historial de Pedidos',
      stock: 'Almacén',
      purchases: 'Compras',
      apriori: 'Apriori',
      probability: 'Probabilidad',
      associations: 'Asociaciones',
      economicSubscriptions: 'Abonos',
    },
    requestNo: 'N° Pedidos',
    totalLast30Days: 'Total últ. 30 días',
    totalSinceLastCashRegister: 'Total desde últ. cierre caja',
    middleTime: 'Tiempo medio',

    box: {
      lastCashRegister: 'Último Cierre de Caja',
      serialNo: 'N°. Serie',
      from: 'Desde',
      to: 'Hasta',
      totalCard: 'Total ventas tarjeta',
      totalCash: 'Total ventas efectivo',
      total: 'Total',
      noCashRegisters: 'Sin cierres de Caja',
      register: 'Cerrar Caja',
      generating: 'Generando Cierre de Caja',
      closeShiftDetails: 'Detalles del cambio de turno',
      closeBoxDetails: 'Detalles del cierre de caja',
      types: 'Tipos',
      wCard: 'Con Tarjeta',
      wCash: 'Con Efectivo',
      totalIncome: 'Ingreso Total',
      initialAmount: 'Saldo inicial en caja',
      totalAmount: 'Importe Total',
      cashRegister: 'Arqueo de caja',
      insertCoinAndBill: 'Introduzca cantidad de Billetes y Monedas',
      closeWithoutRegister: 'Cerrar sin Arqueo',
      totalDiscounted: 'Total descuento',
      totalWithDiscount: 'Total con Descuento',
      unbalance: 'Descuadre caja',
      closingCarriedOutBy: 'Cierre realizado por',
      taxes: 'Total impuestos',
      totalEconomicSubscription: 'Total Abonos',
      totalTips: 'Total propinas',
      totalExpenses: 'Total gastos',
      totalExpensesCash: 'Total gastos efectivo',
      totalExpensesCard: 'Total gastos tarjeta',
      pickupCash: 'Recoger efectivo',
      pickupCard: 'Recoger tarjeta',
      pickupTotal: 'Total recoger',
      domicileCash: 'Domicilio efectivo',
      domicileCard: 'Domicilio tarjeta',
      domicileTotal: 'Total domicilio',
      barCash: 'Barra efectivo',
      barCard: 'Barra tarjeta',
      barTotal: 'Total barra',
      localCash: 'Local efectivo',
      localCard: 'Local tarjeta',
      localTotal: 'Total local',
      globalTotal: 'Total global',
      totalByRequestType: 'Totales por tipo de pedido',
      resume: 'Resumen',
      closeType: 'Tipo de cierre',
      closeBox: 'Cierre de caja',
      closeShift: 'Cambio de turno',
      totalCardBank: 'Total tarjeta en banco',
      cardUnbalance: 'Descuadre tarjeta',
      changeShift: 'Cambiar Turno',
      totalCashBox: 'Total efectivo en caja',
      arqueo: 'Arqueo',
      newClose: '+Nuevo cierre',
      salesResume: 'Desglose de ventas',
      expenseResume: 'Desglose de gastos',
      totalCashInBox: 'Total efectivo en caja',
      totalSales: 'Total ventas',
      totalBase: 'Total base',
      close_box: 'Cierre de caja',
      close_shift: 'Cambio de turno',
    },
    products: {
      filters: 'Filtros',
      serialNo: 'No. Serie',
      name: 'Nombre',
      price: 'Precio',
      frequencyInRequests: 'Frecuencia en Pedidos',
      sales: 'Ventas',
      total: 'Total',
      requestsType: 'Tipo de Pedido',
      from: 'Desde',
      to: 'Hasta',
      noResults: 'Sin Resultados',
      last30Days: 'Más vendidos últ. 30 días',
    },
    stocks: {
      filters: 'Filtros',
      serialNo: 'No. Serie',
      productName: 'Nombre',
      name: 'Nombre',
      stockName: 'Nombre Almacén',
      qty: 'Cantidad',
      price: 'Precio',
      type: 'Tipo',
      total: 'Total',
      from: 'Desde',
      discount: 'Descuento',
      motive: 'Descripción de la actualización',
      to: 'Hasta',
      operator: 'Operador',
      noResults: 'Sin Resultados',
      showStock: 'Ver Stock',
      measures: 'Medidas',
      amountToUpdate: 'Cantidad a actualizar',
      updateStock: 'Actualizar stock',
      willAdd: 'Se añadirá',
      willDiscount: 'Se descontará',
      unitsToStock: 'unidad/es al almacén',
      unitsFromStock: 'unidad/es del almacén',
    },
    requestsHistory: {
      filters: 'Filtros',
      noResults: 'Sin Resultados',
      previewRequest: 'Visualizar Pedido',
      serialNo: 'No. Serie',
      table: 'Mesa',
      creditCard: 'Tarjeta de Crédito',
      dateOfCreation: 'Fecha de Creación',
      price: 'Precio',
      type: 'Tipo de pedido',
      from: 'Desde',
      to: 'Hasta',
      status: 'Estado',
    },
    sales: {
      filters: 'Filtros',
      noResults: 'Sin Resultados',
      previewTable: 'Visualizar Mesa',
      previewRequest: 'Visualizar Pedido',
      serialNo: 'Nº. Serie',
      table: 'Mesa',
      creditCard: 'Tarjeta de Crédito',
      dateOfCreation: 'Fecha de Creación',
      closeDate: 'Fecha de Cierre',
      dateRange: 'Rango de Fechas',
      price: 'Precio',
      type: 'Tipo',
      status: 'Estado',
      from: 'Desde',
      to: 'Hasta',
      exportToExcel: 'Exportar a Excel',
      payment: 'Tipo de Pago',
      date: 'Fecha',
      min: 'Mín',
      max: 'Máx',
      average: 'Promedio',
      estTotal: 'Total Estimado',
      estSales: 'Ventas estimadas(ud)',
      payedBy: 'Cerrado por',
      requestedBy: 'Solicitado por',
      tips: 'Propina',
      paymentMethod: 'Método de pago',
      changePaymentMethod: 'Cambiar método de pago',
      editPayment: 'Editar pago',
      paidBySplit: 'Pagado por separado',
      paid: 'Pagado',
      dateAndHour: 'Fecha y hora',
      amount: 'Monto',
      paymentPlatform: 'Plataforma de pago',
      notFoodeoPayment: 'La comanda no fue pagada con foodeo',
      paidSplitedByProducts: 'La comanda fue pagada separando pagos por productos',
      paidSplitedByPrices: 'La comanda fue pagada separando pagos por precio',
      closeBoxFinished: 'A esta comanda ya se le realizó el cierre de caja',
      fiskalyUrl: 'URL de Fiskaly',
      invoiceType: 'Tipo de factura',
      invoiceVerifactuText: 'Factura verificable en la sede electrónica de la AEAT',
    },
    probability: {
      name: 'Nombre',
      qty: 'Cantidad',
      probability: 'Probabilidad',
      jointProbability: 'Probabilidad Conjunta',
      product1: 'Producto 1',
      product2: 'Producto 2',
    },
    apriori: {
      antecedent: 'Antecedente',
      consequent: 'Consecuencia',
      antecedents_support: 'Antecedente Soporte',
      consequent_support: 'Consecuencia Soporte',
      support: 'Soporte',
      confidence: 'Confianza',
      lift: 'Lift',
      max_len: 'Longitud Máx',
      jointProbability: 'Probabilidad Conjunta',
      product1: 'Producto 1',
      product2: 'Producto 2',
    },
    economicSubscription: {
      createdDate: 'Fecha de Creación',
      serial: 'No. Serie',
      amount: 'Cantidad a abonar',
      noEconomicSubscriptions: 'Sin Abonos',
      commandSerial: 'No. Serie de la Comanda',
      description: 'Descripción',
      creditCard: 'Tarjeta de Crédito',
      positiveCredit: 'Se va a aplicar un abono positivo a la comanda de',
      negativeCredit: 'Se va a aplicar un abono negativo a la comanda de',
    },
    expenses: {
      expenses: 'Gastos',
      amount: 'Importe',
      payedWith: 'Pagado con',
      paymentMethod: 'Método de pago',
      noExpenses: 'Sin Gastos',
      employee: 'Empleado',
      alreadyPaid: 'El gasto ya fue cerrado',
      status: 'Estado',
      onlyNumbers: 'Ingrese solo números',
    },
    dashboard: {
      salesSummary: 'Resumen Ventas',
      averageSummary: 'Ticket Promedio',
      hourlyBillingSummary: 'Pedidos por horas',
      pickDay: 'Seleccione un día',
      date: 'Fecha',
      last30Days: 'Últimos 30 días',
      totalSinceLastCashRegister: 'Desde últ. cierre',
      currentMonth: 'Mes actual',
    },
    widgets: {
      requestNo: 'N° Pedidos',
      middleTime: 'Tiempo medio',
      sales: 'Ventas',
      expenses: 'Gastos',
      benefits: 'Beneficios',
      cardSales: 'Ventas tarjeta',
      cashSales: 'Ventas efectivo',
      pendingSales: 'Ventas pendientes de cerrar',
      productsMostSelled: 'Lo más vendido (Últimos 7 días)',
    },
    invoices: {
      invoices: 'Facturas',
      invoice: 'Factura',
      showInvoices: 'Ver facturas',
      noInvoices: 'Sin facturas',
      date: 'Fecha de factura',
      invoiceNo: 'N° Factura',
      total: 'Total',
      downloadFile: 'Descargar',
      concept: 'Concepto',
      price: 'Precio',
      units: 'Unidades',
      client: 'Cliente',
      dueDate: 'Vencimiento',
      notes: 'Notas',
      subtotal: 'Subtotal',
      year: 'Año',
      all: 'Todos',
    },
    consumptionsReport: {
      consumptions: 'Consumos',
      noConsumptions: 'Sin consumos',
      serial: 'N° Serie',
      name: 'Nombre',
      type: 'Tipo de pedido',
      qty: 'Cantidad',
      unit: 'Unidad',
      productOrIngredient: 'Producto o ingrediente',
      productType: 'Tipo',
      value: 'Valor',
    },
    reportsInfo: {
      salesByMonth: 'Ventas por meses',
      salesByDay: 'Ventas por días',
      salesByProducts: 'Ventas por productos',
      salesByCategories: 'Ventas por categorías',
      salesByRequestTypes: 'Ventas por tipo de pedidos',
      salesByClients: 'Ventas por clientes',
      salesByEmployees: 'Ventas por empleados',
      salesByPaymentMethods: 'Ventas por métodos de pago',
      salesByLocales: 'Ventas por locales',
      expensesByMonth: 'Gastos por meses',
      expensesByDay: 'Gastos por días',
      expensesByDate: 'Gastos por fecha',
      expensesByPaymentType: 'Gastos por tipo de pago',
      expensesByEmployees: 'Gastos por empleados',
      expensesByLocales: 'Gastos por locales',
      reportInfoTypes: 'Tipos de informes',
      salesByDate: 'Ventas por fecha',
      filterType: 'Tipo de filtro',
      discountsByDate: 'Descuentos por fecha',
      discountsByMonth: 'Descuentos por meses',
      discountsByDay: 'Descuentos por días',
      tipsByDate: 'Propinas por fecha',
      tipsByMonth: 'Propinas por meses',
      tipsByDay: 'Propinas por días',
      date: 'Fecha',
      month: 'Mes',
      total: 'Total',
      day: 'Día',
      requestType: 'Tipo de pedido',
      paymentMethods: 'Métodos de pago',
      paymentMethod: 'Método de pago',
      paymentType: 'Tipo de pago',
      local: 'Local',
      barra: 'Barra',
      recoger: 'Recoger',
      domicilio: 'Domicilio',
      salesByDayDownloadNamefile: 'Ventas_por_días',
      salesByMonthDownloadNamefile: 'Ventas_por_meses',
      expensesByDayDownloadNamefile: 'Gastos_por_días',
      expensesByMonthDownloadNamefile: 'Gastos_por_meses',
      discountsByDayDownloadNamefile: 'Descuentos_por_días',
      discountsByMonthDownloadNamefile: 'Descuentos_por_meses',
      tipsByDayDownloadNamefile: 'Propinas_por_días',
      tipsByMonthDownloadNamefile: 'Propinas_por_meses',
      expensesByEmployeeDownloadNamefile: 'Gastos_por_empleados',
      salesByProductsDownloadNamefile: 'Ventas_por_productos',
      salesByCategoriesDownloadNamefile: 'Ventas_por_categorías',
      salesByRequestTypeDownloadNamefile: 'Ventas_por_tipo_de_pedidos',
      salesByClientsDownloadNamefile: 'Ventas_por_clientes',
      salesByEmployeesDownloadNamefile: 'Ventas_por_empleados',
      salesByPaymentMethodsDownloadNamefile: 'Ventas_por_métodos_de_pago',
      salesByLocalesDownloadNamefile: 'Ventas_por_locales',
      expensesByPaymentTypeDownloadNamefile: 'Gastos_por_tipo_de_pago',
      expensesByLocalesDownloadNamefile: 'Gastos_por_locales',
    },
  },
  request: {
    legend: 'Leyenda',
    requests: 'Pedidos',
    domiciles: 'Domicilio',
    tables: 'Mesas',
    cashier: 'Cajón',
    newRequest: 'Nuevo',
    bar: 'Barra',
    various: 'Varios',
    maximize: 'Maximizar',
    closeCash: 'Cerrar Efect.',
    closeCashLong: 'Cerrar efectivo',
        closeCard: 'Cerrar Tjta.',
        closeCardLong: 'Cerrar tarjeta',
    closeWithoutPayment: 'Cerrar Mesa',
    productsToTable: 'Productos a la Mesa',
    editTable: 'Editar Mesa',
    observations: 'Observaciones',
    productObservations: 'Observaciones del producto',addCombined: 'Agregar Combinados',
    noAssociatedProducts: 'No hay productos asociados',
    noAggregatedProducts: 'No hay productos agregados ',
    aggregated: 'Agregados',
    name: 'Nombre',
    settings: 'Opciones',
    type: 'Tipo',
    print: 'Imprimir',
    price: 'Precio',
    amount: 'Cantidad',
    total: 'Total',
    date: 'Fecha',
    requestDate: 'Fecha de solicitud',
    deliveryDate: 'Fecha de entrega',
    pickupDate: 'Fecha de recogida',
    invalidatedBy: 'Invalidado por',
    discount: 'Descuento',
    discountType: 'Tipo de Descuento',
    originalPrice: 'Precio Original',
    finalPrice: 'Precio Final',
    percent: 'Porcentual',
    numeric: 'Numérico',
    with: 'con',
    applyDiscountToAll: 'Aplicar descuento a todo el pedido',
    AddProductsOutsideTheMenu: 'Añade un producto fuera de la carta',
    orderTimeDelay: '¿Qué tiempo demorará el pedido?',
    customOrderTimeDelay: 'Personalizado',
    productOutOfStock: 'Producto agotado',
    requestsTypes: {
      pickUp: 'A Recoger',
      bar: 'Barra',
      domicile: 'Domicilio',
      local: 'Local',
      all: 'Todos',
    },
    requestStatus: {
      all: 'Todos',
      payed: 'Pagado',
      finished: 'Terminado',
      invalidated: 'Invalidado',
      required: 'Solicitado',
    },
    requestCardStatus: {
      solicited: 'Solicitado',
      inProcess: 'En proceso',
      toServe: 'Para servir',
      received: 'Recibido',
      readyForPickup: 'Listo para recogida',
      onTheWay: 'En camino',
    },
    domicile: {
      serialNo: 'No. Serie',
      software: 'Software',
      dealer: 'Repartidor',
      noDealer: 'Sin asignar',
      searchDealer: 'Buscar repartidor',
      status: 'Estado',
      soon: 'Lo antes posible',
      deliveryTime: 'Hora  entrega',
      pickupTime: 'Hora de recogida',
      noAllowShifts: 'No hay turnos disponibles',
      origin: 'Origen',
    },
    overview: {
      noMarked: 'Pendientes',
      marked: 'Tachados',
      overview: 'Resumen',
    },
    rejectRequestTitle: '¿Quieres RECHAZAR el pedido?',
    rejectRequestDescription: 'Esta acción es irreversible, si rechazas el pedido, quedará en estado "Invalidado" y el cliente recibirá un correo de que has rechazado el pedido.',
    closeRequestTitle: '¿Quieres CERRAR el pedido?',
    closeRequestDescription: 'Esta acción es irreversible, si cierra el pedido no podrá recuperarlo.',orderRequestsLabel: 'Ordenar por',
        orderRequestsOptions: {
            creationDate: 'Fecha de creación',
            deliveryDate: 'Fecha de entrega',
        },
        deliveryRequestsRangeLabel: 'Mostrar pedidos a entregar',
        deliveryRequestsRangeOptions: {
            all: 'Todos',
            lessOneHour: 'Menos de 1 hora',
            today: 'Hoy',
            tomorrow: 'Mañana',
            yesterday: 'Ayer',
        },
        searchProduct: 'Buscar producto',
  maxAggregates: 'Elige max',},
  requestTable: {
    serialNo: 'No. Serie',
    type: 'Tipo',
    name: 'Nombre',
    total: 'Total',
    table: 'Mesa',
    date: 'Fecha',
    price: 'Precio',
    introduceReceivedAmount: 'Introduce la cantidad recibida',
    totalToPay: 'Total a Pagar',
    received: 'Recibido',
    amount: 'Cantidad',
    toReturn: 'Devolver',
    toPay: 'Pagar',
    closeCash: 'Cerrar Efect.',
    closeCard: 'Cerrar Tjta.',
    cashier: 'Cajón',
    print: 'Imprimir',
    change: 'Cambiar',
    split: 'Separar',
    settings: 'Ajustes',
    payed: 'Pagado',
    restorePayments: 'Restaurar Pagos',
    finalizedPayments: 'Finalizar Pagos',
    amountToPay: 'Monto a Pagar',
    various: 'Varios',
    accountOptions: 'Opciones de Cuenta',
    selectWaiter: 'Seleccionar Camarero',
    invoice: 'Factura',
    actualizedContent: 'Contenido Actualizado',
    nonValidTable: 'Los productos no son válidos, la mesa ha sido',
    actualized: 'actualizada',
    closed: 'cerrada',
    splitByPrice: 'Separar pedidos por precio',
    splitPrice: 'Separar por precios',
    splitProduct: 'Separar por productos',
    noProductsToPay: 'No hay Productos por pagar',
    noPayedProducts: 'No hay productos pagados',
    payedProducts: 'Productos Pagados',
    payCard: 'Pagar con tarjeta',
    payCash: 'Pagar con efectivo',
    paymentDone: 'Pago Finalizado',
    paymentPending: 'Pendiente de pago',
    pendingReturn: 'Pendiente de devolución',
    subTotal: 'Subtotal',
    commandId: 'Id de la Comanda',
    command_guests: 'Comensales',
    details: 'Nota',
    invalidAmount: 'El monto debe ser mayor a 0',
    moreOptions: 'Más opciones',
    toAddComment: 'Para agregar comentarios, presione el nombre del producto',
    card: 'Tarjeta',
    cash: 'Efectivo',
  },
  requestTableStatus: {
    available: 'Libre',
    busy: 'Ocupado',
    pendingPay: 'Pendiente de pago',
    blocked: 'Bloqueada, esperando pago',
  },
  shift: {
    noShifts: 'Sin Turnos',
    from: 'Desde',
    to: 'Hasta',
    capacity: 'Capacidad',
    clientPerShift: 'Número de clientes por turno',
    closedDays: 'Días Cerrados',
  },
  option: {
    noOptions: 'Sin Opciones',
    title: 'Título',
    description: 'Descripción',
    clientSelectableAnswers: 'Respuestas a seleccionar por el cliente',
    answers: {
      title: 'Título',
      description: 'Descripción',
    },
  },
  booking: {
    today: 'Hoy',
    left: 'Restante',
    day: 'Día',
    month: 'Mes',
    week: 'Semana',
    diners: 'Comensales',
    client: 'Cliente',
    options: 'Opciones',
    answer: 'Respuesta',
    addBooking: 'Agregar Reserva',
    reserve: 'Reservar',
    ability: 'Capacidad disponible',
    reservationDate: '{day} de {month} de {start} a {end}',
    notAllowedCapacity: 'Cantidad no permitida',
  turn: 'Turno',
        command_guests: 'Comensales',
        name: 'Nombre',
        phone: 'Teléfono',
        table: 'Mesa',
        observations: 'Observaciones',
        actions: 'Acciones',
        edit: 'Editar',
        all: 'Todos',
        date: 'Fecha',
        noTurns: 'No hay reservas hoy',},
  payment: {
    types: {
      cash: 'Efectivo',
      creditCard: 'Tarjeta de Crédito',
      both: 'Ambos',
    },
    dojo: {
      tableBeingPayed: 'Espere... La mesa está siendo pagada',
      requestBeingPayed: 'Espere... El pedido está siendo pagado',
      successfulPayment: 'La mesa fue pagada correctamente',
      errorPayment: 'Se agotó el tiempo de espera, revise su pago manualmente o reintente',
      declinedCard: 'La tarjeta insertada no es válida',
      operationCancelled: 'La operación fue cancelada',
      operationCancelling: 'Cancelando...',
      signVerification: 'Verificacion de firma en progreso',
      confirm: 'Confirmar',
      timeout: 'Confirmar en el datáfono si la transacción se ha completado correctamente',
      unavailable: 'El datáfono no está disponible en estos momentos, por favor, intente en 10 segundos, revise la pantalla PDQ o reinicie el PDQ. Contacte a soporte si el problema persiste',
      error: 'Error en la configuración de dojo, contacte con Foodeo',
      selectDataphone: 'Seleccione datáfono',
      mustAddDataphone: 'Debe añadir un datáfono',
    },
    cashmatic: {
      tableSuccessfulPayment: 'La mesa fue pagada correctamente',
      requestSuccessfulPayment: 'El pedido fue pagado correctamente',
      error: 'Ha ocurrido un error en el proceso de pago, intente nuevamente o contacte con Foodeo',
      noCancelled: 'No se ha podido cancelar el pago',
      timeOut: 'El tiempo de espera del pago ha expirado. Por favor, intente realizar su pago nuevamente. Si el problema persiste, contacte con Foodeo.',
      notDispensedAmount: 'Importe no dispensado',
    }
  },
  settings: {
    app: {
      app: 'APP',
      notifyText: 'Texto de Notificaciones',
      localPayments: 'Pagos Locales',
      domicilePayments: 'Pagos Domicilio',
      pickUpPayments: 'Pagos a Recoger',
    },
    domicile_pickup: {
      domicile_pickup: 'Delivery',
      blockOrders: 'Bloquear Pedidos',
      allowOrders: 'Permitir Pedidos',
      closed: 'Cerrado',
      open: 'Abierto',
      schedules: 'Horarios',
      priceServiceDomicile: 'Precio  domicilio',
      minimumAmountForDomicile: 'Importe mínimo para domicilio',
      autoAcceptDomicile: 'Aceptar pedidos de domicilio automáticamente',
      autoAcceptPickup: 'Aceptar pedidos de recoger automáticamente',
      allowDelivery: 'Permitir pedidos a domicilio',
      allowPickup: 'Permitir pedidos a recoger',
      orderTimeDelay: 'Tiempo de demora de pedidos',
      addOrderTime: 'Añadir tiempo',
      time: 'Tiempo',
      deleteTime: 'Eliminar tiempo',
      noOrdersTime: 'Sin tiempos configurados',
      noMoreOptions: 'No puede añadir más de 3 opciones',
      alreadyExist: 'Ya existe esa opción',
      shiftDuration: 'Duracion de cada turno en minutos',
      max2h: 'El máximo permitido es de 120min',
      minimumAdvanceDomicile: 'Antelación mínima domicilio',
      minimumAdvancePickup: 'Antelación mínima recoger',
      maxProductsByTurn: 'Número de productos máximo por turno',
      limitedCategories: 'Categorías limitadas',
      domicileOrdersLimit: 'Límite de pedidos a domicilio',
      maxAddressesRange: 'Radio máximo para pedidos a domicilio',
      request_without_client_domicile: 'Permitir pedidos sin cliente domicilio',
      request_without_client_pickup: 'Permitir pedidos sin cliente recoger',
    },
    global: {
      globals: 'General',
      globalSettings: 'Configuraciones Globales',
      iva: 'IVA',
      minStockAlert: 'Alerta de mínimo de stock alcanzado',
      showCombinedAggregatedCategories: 'Mostrar categorías agregados/combinados',
      localId: 'ID Local',
      newRequestSound: 'Reproducir sonido cuando entre un nuevo pedido',
      printBy: 'Imprimir por',
      useVibrant: 'Usar Vibrant',
      useKeyboard: 'Usar teclado virtual',
      selectUserBeforeOrder: 'Seleccionar empleado antes de cada pedido',
      useModifiers: 'Usar Modificadores',
      usePaymentTerminal: 'Usar datáfonos',
      useCashmatic: 'Usar cashmatic',
      localAddress: 'Dirección del comercio',
      addressPlaceholder: 'Busca una dirección...',
      getGeolocation: 'Usar geolocalización',
      addressWithoutCoordinates: 'Debe seleccionar una dirección en el mapa, usa el buscador para encontrarla',
      closeBarOrderAuto: 'Cerrar pedido automáticamente en barra',
      timeZone: 'Zona Horaria',
    },
    kitchenTicket: {
      kitchenTicket: 'Configuración ticket de cocina',
      showLocalHeadings: 'Mostrar encabezados en pedidos Locales',
      showDomicileHeadings: 'Mostrar encabezados en pedidos a Domicilio/Recoger',
      showUnitaryPrice: 'Mostrar precio unitario',
      showTotalPrice: 'Mostrar precio total',
      groupProductsByOrders: 'Agrupar Productos por Orden',
      sendNameInTicket: 'Mostrar nombre del camarero',
      headingStyle: 'Estilo del Encabezado',
      font: 'Fuente',
      size: 'Tamaño',
      style: 'Estilo',
      productsStyle: 'Estilos de Productos',
    },
    ticket: {
      ticket: 'Ticket',
      usePrinter: 'Usar Impresora',
      ticketInfo: 'Información del Ticket',
      ticketHeading: 'Nombre del local',
      phone: 'Número telefónico',
      socialReason: 'Razón social',
      nifCif: 'Nif / Cif',
      fullAddress: 'Dirección completa',
      amountOfClientTickets: 'Nº tickets cliente',
      amountOfKitchenTickets: 'Nº tickets cocina',
      printKitchenTicketIn: 'Imprimir ticket de cocina automáticamente en',
      printClientTicketIn: 'Imprimir ticket de cliente automáticamente en',
      domicilePickUpRequests: 'Pedidos a Domicilio/Recoger',
      localRequests: 'Pedidos Locales',
      barRequests: 'Pedidos Barra',
      printOptions: 'Opciones de Impresión',
      printBy: 'Imprimir por',
      combinedPrintBehavior: 'Comportamiento de impresión de combinados',
      aggregatedPrintBehavior: 'Comportamiento de impresión de agregados',
      samePrinterAsContainerProduct: 'Misma impresora del producto que lo contiene',
      categoryPrinter: 'Impresora de su categoría',
      main_printer: 'Impresora principal por TPV',
      use_main_printer: 'Usar impresora principal por TPV',
      ticket_text: 'Texto del pie del ticket',
      showPrintTicketClientInfo: 'Activa estas opciones si quieres que se imprima un ticket de cliente (la cuenta) automáticamente al realizar cualquiera de los siguientes tipos de pedido.',
      showPrintTicketKitchenInfo: 'Activa estas opciones si quieres que se imprima un ticket de cocina automáticamente al realizar cualquiera de los siguientes tipos de pedido.',
      printBeforeClose: 'Al cerrar comanda',
    },
    digitalMenu: {
      digitalMenu: 'Carta Digital',
      logo: 'Logotipo',
      headlineImage: 'Imagen de cabecera',
      title: 'Título',
      subtitle: 'Subtítulo',
      description: 'Descripción',
      mainColor: 'Color principal',
      backgroundColor: 'Color de fondo',
      headlineBackgroundColor: 'Color de fondo de la cabecera',
      minDomicileRequest: 'Pedido mínimo domicilio',
      allowTips: 'Permitir propinas',
      email: 'Correo para aviso legal',
      bookings: 'Reservas',
      call_waiter: 'Llamar al camarero',
      local_orders: 'Pedidos en mesa',
      useAwards: 'Habilitar premios',
      showBookingsInfo: 'Si activas esta opción permites a los clientes hacer reservas desde la carta digital.',
      showCallWaiterInfo: 'Si activas esta opción se muestra una opción en el menú para llamar al camarero, cuando un cliente pulse en esta opción se mostrará una alerta en el TPV de que el cliente está solicitando un camarero.',
      showLocalOrdersInfo: 'Si activas esta opción permites a los clientes hacer pedidos desde el código QR en la mesa.',
      showAllowTipsInfo: 'Si activas esta opción les aparecerá a los clientes una opción para añadir propinas al finalizar su pedido en la carta digital.',
      showUseAwardsInfo: 'Si la opción está activada, aparecerá la opción de Premios en la carta digital',
      confirmationMessageForKioskoInCash: 'Mensaje pedido aceptado en efectivo Kiosko',
      confirmationMessageForKioskoInCard: 'Mensaje pedido aceptado en tarjeta Kiosko',
      confirmationMessageForDigitalMenu: 'Mensaje pedido aceptado en carta digital',
      kioskHeadlineImage: 'Imagen de cabecera para kiosko',
    },
    booking: {
      booking: 'Reservas',
      minClients: 'Mínimo de comensales por reservación',
      maxClients: 'Máximo de comensales por reservación',
      emailNotification: 'Correo de notificaciones',
    },
    stock: {
      defaultStock: 'Almacén predeterminado',
      showDefaultStockInfo: 'El almacén predeterminado es el que se usará para descontar los productos automáticamente.'
    },
  },
  units: {
    name: 'Nombre',
    type: 'Tipo',
    noUnits: 'Sin unidades personalizadas',
    value: 'Cantidad',
    unit_reference: 'Unidad de referencia',
    customeUnits: 'Unidades de medidas personalizadas',
    measures: 'Unidades de medidas',
    configUnits: 'Configurar unidades de medida',
    showCustomUnitsInfo: 'Las unidades de medida personalizadas en Foodeo sirven para gestionar tus productos e ingredientes de manera más eficiente. Te pemiten comprar productos en cantidades específicas. Por ejemplo, puedes crear una unidad "Caja Cocacola" para comprar 24 unidades juntas. Más info: <a href="https://academy.foodeo.es/es/articles/9864204-como-crear-unidades-de-medida-personalizadas" target="_blank">¿Cómo crear unidades de medida personalizadas? | Centro de ayuda</a>',
  },
  stock: {
    name: 'Nombre',
    serial: 'Serie',
    description: 'Descripción',
    minReach: 'La cantidad de producto se encuentra por debajo del mínimo permitido en configuraciones',
    serialNo: 'No. Serie',
    amount: 'Cantidad',
    amountToDiscount: 'Cantidad a descontar',
    price: 'Precio',
    category: 'Categoría',
    activated: 'Activado',
    allergens: 'Alérgenos',
    location: 'Localización',
    noStocks: 'Sin Almacenes',
    payment: 'Abono',
    cannotDeleteStock: 'No puede quedarse sin almacenes.',
    selectStock: 'Seleccione un almacén',
  history: 'Historial',
        modificationsHistory: 'Historial de modificaciones',
        date: 'Fecha',},
  category: {
    noCategories: 'No hay Categorías',
    noCategoriesCreated: 'No hay categorías creadas', companion: 'Acompañante',
    aggregated: 'Agregado',
    children: 'Hijo',
    name: 'Nombre',
    image: 'Imagen',
    appText: 'Texto a mostrar',
    subCategory: 'Subcategoría', hasSubcategories: 'Tiene Subcategorías',
    hasSubcategoriesInfo: 'Permite añadir una o mas subcategorías a la categoría. Por ejemplo, la categoría "Copas" podría tener como subcategorías a "Refrescos" y "Vinos", para agruparlos en la app.',
    hasCompanion: 'Tiene Acompañantes',
    hasCompanionInfo: 'Permite añadir un acompañante a la categoría. Por ejemplo la categoría "Copas", podría tener como acompañante a "Refrescos", para poder permitir seleccionar un único refresco a tu copa.',
    hasAggregated: 'Tiene Agregados',
    hasAggregatedInfo: 'Permite añadir uno o más agregados a la categoría. Por ejemplo, la categoría "Pizzas" podría tener como agregados a "Ingredientes", para poder agregar varios extras a la categoría.',
    activatedInfo: 'Esta opción permite activar/desactivar las categorías, en caso de estar la categoría desactivada, ésta no se mostrará a la hora de hacer un pedido.',
    available: 'Disponible',
    availableInfo: 'Si la opción está desactivada, cuando cualquier usuario haga un pedido, le aparecerá un mensaje indicando que no se puede hacer un pedido de esta categoría en estos momentos. Se utiliza si tienes mucho trabajo en cocina y quieres pausar los pedidos.',
    clientActivated: 'Activado Cliente',
    clientActivatedInfo: 'Esta opción permite activar/desactivar las categorías para clientes, en caso de estar la categoría desactivada, ésta no se mostrará a los clientes en la carta.',
    order: 'Orden',
    showCategoryName: 'Mostrar el nombre de las categorías',
  maxAggregates: 'Máximo de agregados',
    },

  videos: {
    productsSubtitle: 'Desde la página de Productos podrás crear los productos de la carta. Puedes ver el siguiente vídeo para más información.',
    categoriesSubtitle: 'Desde la página de Categorías podrás crear las categorías de la carta. Puedes ver el siguiente vídeo para más información.',
    tablesSubtitle: 'Desde la página de Mesas puedes crear las mesas para poder asignarlas a las Zonas y así componer el local. Puedes ver el siguiente vídeo para más información.',
    zonesSubtitle: 'Desde la página de Zonas puedes crear las zonas del local y asignar las mesas y el TPV. Puedes ver el siguiente vídeo para más información.',
    screensSubtitle: 'Desde la página de Pantallas puedes crear las pantallas del local y gestionar tus pedidos. Puedes ver el siguiente vídeo para más información.',
    awardsSubtitle: 'Desde la página de Premios puedes crear los premios que podrán canjear los clientes con sus puntos. Con cada euro que gaste el cliente conseguirá 2 puntos.',
    employeesSubtitle: 'Desde la página de Empleados puedes crear los empleados y asignarles el rol correspondiente.',
    clientsSubtitle: 'Desde la página de Clientes puedes ver todos los clientes que has registrado en el sistema.',
    printersSubtitle: 'Desde la página de Impresoras puedes configurar las impresoras para poder imprimir los tickets de cocina y de cliente. Debes asignar las categorias y zonas correspondientes  a cada impresora. Solo puede haber una impresora principal por TPV. El resto deberán asignarse como TPV secundario. Puedes ver el siguiente vídeo para más información.',
    cashiersSubtitle: 'Desde este página puedes crear los cajones y asignarlos a la impresora. Por defecto el pulso suele ser de 200 y el puerto es el 0.',
    familiesSubtitle: 'Desde la página de Familias puedes crear familias para agrupar las categorías, de esta forma podrás imprimir en una misma impresora tickets por separado. Puedes ver el siguiente vídeo para más información.',
    boxReportSubtitle: 'Desde la página de Cierre de caja puedes realizar el cierre de caja o de turno. No es necesario abrir turno, el cierre de caja contabiliza desde el último cierre de caja realizado hasta el cierre actual. Puedes ver el siguiente vídeo para más información',
    shiftsSubtitle: 'Los turnos sirven para poder crear las reservas y asignarlas a los turnos. Cada turno tendrá un horario y una cantidad máxima de comensales. De esta forma cuando se cree una reserva a un turno, se descontarán automáticamente los comensales del turno indicado. Debes crear tantos turnos como posibilidades tenga el cliente de crear una fecha.',
    bookingOptionsSubtitle: 'Desde la pantalla de Opciones puedes crear distintas opciones para tus reservas, por ejemplo podrías crear la opción terraza y la opción interior, para que los clientes puedan elegir la opción que deseen.',
    bookingsSubtitle: 'Desde la pantalla de Calendario puedes ver las reservas de los clientes, también es posible crear una reserva nueva. Puedes cambiar la vista a día, semana o mes.',
    reportsSubtitle: `<p>Desde la pantalla de Reportes tienes varias opciones:</p>
      <p> <strong>DASHBOARD</strong>: Podemos observar una serie de widgets para ver la facturación de los últimos 30 días o desde el último cierre de caja.</p>
      <p> <strong>VENTAS</strong>: Podemos ver las ventas realizadas en el local y filtrarlas por distintas opciones como tipo de pedido. Cambiando el reporte a Productos puedes ver los productos más vendidos y filtrar por categoría.</p>
      <p> <strong>GASTOS</strong>: En la pantalla de Gastos podemos ver los reportes de Gastos, Compras y Abonos.</p>
      <ol type="i">
        <li>Gastos: Aquí se mostrarán todos los gastos que hemos hecho, como, quien y cuando se han hecho. Desde esta pantalla podemos añadir un gasto por ejemplo si hacemos una compra a un proveedor.</li>
        <li>Abonos: Los abonos sirven para añadir o descontar un importe a una mesa que ya esté cerrada, pero antes de que se haya hecho el cierre de caja.</li>
        <li>Compras: Las compras muestran las compras que se han hecho a proveedores para abestecer el stock. Solo estará operativo si tienes contratado el módulo de stock.</li>
      </ol><p></p>
      <p> <strong>PREDICCIONES</strong>: Desde el reporte de Predicciones de Ventas podemos ver las ventas estimadas en una fecha determinada. Desde el reporte de Predicciones de Productos podemos ver los distintos productos que se preveen vender. Desde el reporte de Predicciones de Asociaciones es posible ver la probabilidad de que varios productos se hayan comprado conjuntamente.</p>`,
    settingsSubtitle: 'Desde la pantalla Configuraciones podemos realizar distintas configuraciones como por ejemplo los tickets, configurar el diseño de la carta digital o establecer los turnos de las reservas.',
    stockReportSubtitle: 'Desde la pantalla de Stock podemos ver todos los productos que quedan en los almacenes y descontar las cantidades manualmente.',
    recipesSubtitle: 'En la pantalla de Escandallos puedes ver todos tus productos y conocer cual es el margen de beneficios de cada plato. Pulsando en el producto podrás ver y modificar el precio del producto y el precio de compra, si el producto tiene ingredientes para sacar el margen de beneficio sumará el total de todos los ingredientes. También podrás visualizar los ingredientes de cada plato.',
    purchasesSubtitle: 'Desde la pantalla de Compras podemos realizar las compras para componer el Stock.',
    stockSubtitle: 'Desde la pantalla de Almacenes podemos crear los almacenes para luego realizar las compras y guardar los productos en los almacenes.',
    providerSubtitle: 'Desde la pantalla de Proveedores podemos crear los proveedores para asignar cada compra a un proveedor y tener un control de a quién realizamos las compras.',
    ingredientsSubtitle: 'Desde la pantalla de Ingredientes podemos crear los ingredientes de los productos, para poder asignar estos ingredientes a los productos. De esta forma cuando nosotros vendamos un producto, se descontarán los ingredientes del Stock.',
  },
  modifier: {
    name: 'Nombre',
    appText: 'Texto a mostrar',
    description: 'Descripción',
    min: 'Mínimo',
    max: 'Máximo',
    image: 'Imagen',
    minShort: 'Min',
    maxShort: 'Max',
    addModifier: 'Agregar Modificador',
    addOption: 'Agregar Opción',
    searchOption: 'Buscar Opción',
    searchModifier: 'Buscar Modificador',
    options: 'Opciones',
    isQuantifiable: 'Es cuantificable',
    isRequired: 'Es requerido',
    addedPrice: 'Precio Agregado',
    amount: 'Cantidad',
    chooseMinMax: 'Elige Min {0} y Max {1}',
    addProductsCategories: 'Agregue Productos/Categorías',
    noOptions: 'No hay opciones',
    noModifiers: 'Sin Modificadores',
    lessOptionsThanMin: 'El modificador tiene menos opciones que el minimo a seleccionar',
    moreThanMax: 'Has seleccionado mas del máximo',
    lessThanMin: 'Has seleccionado menos del mínimo',
    amountToDiscount: 'Cantidad a descontar del almacen',
    mustBeMoreThanMinimum: 'La cantidad debe ser mayor o igual que el mínimo',
    mustBeLessThanMaximum: 'La cantidad debe ser menor o igual que el máximo',
    maxReached: 'Has alcanzado el máximo de opciones',
    amountToSelect: 'Cantidad de modificadores a elegir',
    optionAmountToSelect: 'Cantidad de opciones a elegir'
  },
  timeTracking: {
        noEmployees: "No hay empleados",
        enterPassword: "Introducir contraseña",
        password: "Contraseña",
        access: "Acceder",
        currentWorkSession: "Jornada de trabajo de hoy",
        enter: "Entrada",
        stop: "Detener",
        thisWeek: "Esta semana",
        thisMonth: "Este mes",
        wrongPassword: "Contraseña incorrecta",
        day: "Fecha",
        timeRange: "Horario",
        total: "Total",
        from: "Desde",
        to: "Hasta",
        forbiddenSessionEdit: "No se puede editar sesión de otro empleado",
    }
};
